import { TatumAccountData } from 'interfaces/tatumAccountData.interface';
import { axios } from '../interceptors/request.interceptor';
import { API_BASE_URL } from 'constant';
import { TatumAccountAddress } from 'interfaces/tatumAccountAddress.interface';

export const createTatumAccount = async () => {
  const url = `${API_BASE_URL}tatum/create`;
  return await axios.post<TatumAccountData>(url);
};

export const getTatumAddress = async (id: string) => {
  const url = `${API_BASE_URL}tatum/account/address`;
  return await axios.post<TatumAccountAddress>(url, {
    id,
  });
};

export const getTatumAccountDetails = async (id: any) => {
  const url = `${API_BASE_URL}tatum/account/details/${id}`;
  return await axios.get<TatumAccountData>(url);
};

// export const mintNftTatum = async (walletAddress: string, nftUrl: string) => {
//   const url = `${API_BASE_URL}tatum/mint`;
//   return await axios.post<TatumAccountData>(url, {
//     url: nftUrl,
//     walletAddress,
//   });
// };

// export const addAddressAsNftMinter = async () => {
//   const url = `${API_BASE_URL}tatum/mint/add`;
//   return await axios.post(url);
// };

// export const getNftAddressAndTokenId = async (walletAddress: string) => {
//   const url = `${API_BASE_URL}tatum/nft/address-and-id/${walletAddress}`;
//   return await axios.get(url);
// };

// on time use api
export const createNftAuctionTatum = async (
  feeRecipient: string,
  auctionFee: number
) => {
  const url = `${API_BASE_URL}tatum/nft/auction`;
  return await axios.post(url, {
    feeRecipient,
    auctionFee,
  });
};

export const createContractAddress = async (txId: string) => {
  const url = `${API_BASE_URL}tatum/create/address/${txId}`;
  return await axios.get(url);
};

// on time use api
export const deploySmartContract = async () => {
  const url = `${API_BASE_URL}tatum/deploy/smartcontract`;
  return await axios.post(url);
};

export const approveNftAuction = async (tokenId: string) => {
  const url = `${API_BASE_URL}tatum/auction/approve`;
  return await axios.post(url, {
    tokenId,
  });
};

export const sellNftAuction = async (
  nftAddress: string,
  seller: string,
  id: string,
  tokenId: string,
  endedAt: number
) => {
  const url = `${API_BASE_URL}tatum/sell/nft`;
  return await axios.post(url, {
    nftAddress,
    seller,
    id,
    tokenId,
    endedAt,
  });
};

export const bidNftAuction = async (id: string, bidValue: string) => {
  const url = `${API_BASE_URL}tatum/bid/nft`;
  return await axios.post(url, {
    id,
    bidValue,
  });
};

export const settleNftAuction = async (contractAddress: string, id: string) => {
  const url = `${API_BASE_URL}tatum/settle/nft`;
  return await axios.post(url, {
    contractAddress,
    id,
  });
};
